import PasswordHolder from './PasswordHolder'

export default PasswordHolder
